import VatReport from '@/vat/VatReport.vue'

export const VAT_REPORT = { componentName: 'VatReport', component: VatReport, meta: { requiresOrg: true } }